// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p2UKpGqDR7M10OLr{max-width:400px;width:100%;text-align:center}.U58QDamucUcN7LGI{max-width:400px;width:100%}.p8rGosGc2YDnnuno{max-width:358px;margin:0 auto}.p8rGosGc2YDnnuno .pt9Pg6JxK8sG4uwW{height:70px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContent": `p2UKpGqDR7M10OLr`,
	"modalHeader": `U58QDamucUcN7LGI`,
	"messageContainter": `p8rGosGc2YDnnuno`,
	"messageEditor": `pt9Pg6JxK8sG4uwW`
};
export default ___CSS_LOADER_EXPORT___;
